import { NavLink } from "react-router-dom";
import { Home } from "lucide-react";

export default function TopNavigator() {
  return (
    <div className="bg-white border-b border-slate-200 shadow-sm px-4 sm:px-6 py-3 flex items-center">
      
      <NavLink
        to="/"
        className={({ isActive }) =>
          `flex items-center gap-2 px-4 py-2 rounded-2xl text-sm font-semibold transition-all duration-200 ${
            isActive
              ? "bg-blue-600 text-white shadow-md"
              : "text-slate-700 hover:bg-slate-100"
          }`
        }
      >
        <Home size={18} />
        Home
      </NavLink>

    </div>
  );
}